<template>
  <div class="mb-ui-video" style="height: 1080px" v-if="showActivator && videoObj">
    <b-sidebar
      :key="'video-side-bar-' + videoIndex"
      v-for="(videoO, videoIndex) in videoObj.video"
      :id="'mb-video-sidebar-' + videoIndex"
      class="side-video"
      :title="videoO.name ? videoO.name : titleText"
      right
      no-header
      backdrop
      :width="videoO.width ? videoO.width + 'px' : '1500px'"
      :height="'1080px'"
      bg-variant="dasdad"
      shadow
      @change="showActivatorFunc"
      sidebar-class="slider-canvas-parameter"
    >
      <template #default="{ hide }">
        <div class="video" :style="[{ background: videoObj.bcg }]">
          <div class="header-container">
            <h4 style="text-align: left">{{ videoO.name ? videoO.name : titleText }}</h4>
            <button type="close" name="close" @click="hide" class="close-button">
              <svg fill="#ffffff" height="55" viewBox="0 0 24 24" width="55">
                <path
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                  fill="rgb(230, 230, 230)"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </button>
          </div>
          <video width="1280" height="720" id="mb-ui-video-player" controls crossorigin playsinline>
            <source :src="giveMeImagePlease(videoO.src)" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div class="video-title">
            <span v-html="videoO.title"></span>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
/**
 * @namespace MbUiVideo
 */

/**
 * przesyłane Propsy
 * @property {Object} videoObj - zawiera dane niezbędne do stworzenia sidebaru z obrazkiem
 * @property {String} titleText - nazwa sidebaru (wyświetlana na górze elementu)
 * @property {null} showActivator - Boolowska wartość czy panel ma być widoczbt czt bue
 *
 * @property {Array} imgaes zawiera X elementów (każy ma osobny button!) objekt w tablicy images musi zawierac tylko src!
 * @example
 *  {
 *     type: 'MbUiVideo',
 *     images: [
 *       {
 *         name: 'Paweł',
 *         src: 'games/page095_game0/img/mapa.jpg',
 *         width: 1500,
 *         style: { height: '120px', background: 'blue' },
 *       },
 *     ],
 *   },
 *
 */
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
export default {
  name: 'mb-ui-video',
  props: {
    videoObj: {
      type: Object,
      default: function () {
        return {};
      },
    },
    titleText: {
      type: String,
      default: function () {
        return '';
      },
    },
    showActivator: {
      type: null,
      default: function () {
        return true;
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const player = new Plyr(document.getElementById('mb-ui-video-player'));
    },
    /**
     * @method giveMeImagePlease
     * @param  {String}  path ścieżka do elementu
     * @return {String}       ścieżka do elementu z uwzględnieniem aktywnego multibooka i ścieżki statycznej
     */
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * @method showActivatorFunc
     * @param  {event}  e zdarzebie
     * emituje zdarzenie u rodzica
     */
    showActivatorFunc(e) {
      if (!e) {
        let video = document.getElementById('mb-ui-video-player');
        video.pause();
        video.currentTime = 0;
      }
      this.$emit('showActivator', { payload: e });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-container {
  padding: 0.5rem 1rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.mb-ui-video {
  display: flex;
}
.video {
  display: flex;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
}
.video-title {
  padding-top: 1vmin;
  padding-bottom: 1vmin;
  font-size: 3vmin;
  z-index: 17;
}
#sidebar-right {
  width: 1500px;
  height: 1080px !important;
}
#mb-video-sidebar-0,
#mb-video-sidebar-1,
#mb-video-sidebar-2,
#mb-video-sidebar-3,
#mb-video-sidebar-4 {
  min-height: 1080px !important;
  height: 1080px !important;
}
.b-sidebar-backdrop {
  height: 1080px !important;
}
/* .slider-canvas-parameter {
} */
</style>
<style lang="sass">
@import '~@/assets/sass/iconColor'
@import '~@/assets/sass/variable'
#mb-video-sidebar-0,
#mb-video-sidebar-1,
#mb-video-sidebar-2,
#mb-video-sidebar-3,
#mb-video-sidebar-4
  background: var(--color)

.close-button
  pointer-events: auto
  top: 0
  right: 0
  opacity: 1
  z-index: 1003
  cursor: pointer
  outline: none
  border: none
  background-color: $backgroundControlPanelColor
  border-radius: 50%
  display: flex
  transform: scale(1)
  padding: 0
  svg
    path:first-child
      fill: $bacgroundColor
      transition: all 0.4s ease
  &:hover
    svg
      path:first-child
        fill: $closeActiveColor
        transition: all 0.4s ease
    transition: all 0.4s ease
  img
    width: 100%
    height: 100%
</style>
